export const GET_LIST_MMC_SUCCESS = 'GET_LIST_MMC_SUCCESS';
export const GET_LIST_PROVINCES_SUCCESS = 'GET_LIST_PROVINCES_SUCCESS';
export const GET_LIST_MERCHANT_BY_PHONE = 'GET_LIST_MERCHANT_BY_PHONE';
export const GET_LIST_MERCHANT_BY_CODE = 'GET_LIST_MERCHANT_BY_CODE';
export const GET_LIST_SHOP_BY_MERCHANT_CODE = 'GET_LIST_SHOP_BY_MERCHANT_CODE';
export const UPDATE_STEP = 'UPDATE_STEP';
export const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';
export const CHOOSED_MERCHANT = 'CHOOSED_MERCHANT';
export const CHOOSED_SHOP = 'CHOOSED_SHOP';
export const GET_LIST_SERVICE = 'GET_LIST_SERVICE';
export const UPDATE_SEND_DATA = 'UPDATE_SEND_DATA';
export const UPDATE_SELECTED_SERVICES = 'UPDATE_SELECTED_SERVICES';
